import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

/** Отступ подсказки от края экрана, px */
const VIEWPORT_GUTTER = 8;

/** Не даёт подсказке прижаться вплотную к краю экрана */
const KEEP_IN_VIEWPORT = [
  { name: 'preventOverflow', options: { padding: VIEWPORT_GUTTER } }
];

export const TooltipDark = styled(
  ({ className, slotProps, ...props }: TooltipProps) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      slotProps={{
        ...slotProps,
        popper: {
          modifiers: KEEP_IN_VIEWPORT,
          ...(slotProps?.popper as object)
        }
      }}
    />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: `min(375px, calc(100vw - ${VIEWPORT_GUTTER * 2}px))`,
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.custom.tooltip.dark
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.custom.tooltip.dark
  }
}));
